module.exports = __webpack_public_path__ + "img/Currency-new.2e36bc35.svg";